import { ValidationErrors, ValidatorFn } from '@angular/forms';
import { AbstractControl } from '@angular/forms';

export function dateFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const datePattern = /^\d{2}-\d{2}-\d{4}$/;
    const value = control.value;

    if (value && value.length < 10) {
      return { dateOfBirthMinLength: true };
    }

    return datePattern.test(value) ? null : { dateFormatInvalid: true };
  };
}
